var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-837 -6354C-837 -6355.1 -836.105 -6356 -835 -6356H37610C37611.1 -6356 37612 -6355.1 37612 -6354V1532C37612 1533.1 37611.1 1534 37610 1534H-834.999C-836.104 1534 -837 1533.1 -837 1532V-6354Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-835 -6355H37610V-6357H-835V-6355ZM37611 -6354V1532H37613V-6354H37611ZM37610 1533H-834.999V1535H37610V1533ZM-836 1532V-6354H-838V1532H-836ZM-834.999 1533C-835.552 1533 -836 1532.55 -836 1532H-838C-838 1533.66 -836.656 1535 -834.999 1535V1533ZM37611 1532C37611 1532.55 37610.6 1533 37610 1533V1535C37611.7 1535 37613 1533.66 37613 1532H37611ZM37610 -6355C37610.6 -6355 37611 -6354.55 37611 -6354H37613C37613 -6355.66 37611.7 -6357 37610 -6357V-6355ZM-835 -6357C-836.657 -6357 -838 -6355.66 -838 -6354H-836C-836 -6354.55 -835.552 -6355 -835 -6355V-6357Z",
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5991,
    transform: "translate(-352 -5660)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 744,
    transform: "translate(-352 -413)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-272 -331C-272 -339.837 -264.837 -347 -256 -347H992C1000.84 -347 1008 -339.837 1008 -331V248C1008 256.837 1000.84 264 992 264H-256C-264.837 264 -272 256.837 -272 248V-331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5262 13.5863C26.0372 12.7165 25.5066 12.5566 24.4262 12.4957C23.347 12.4225 20.6331 12.3921 18.2819 12.3921C15.9263 12.3921 13.2112 12.4225 12.1331 12.4946C11.055 12.5566 10.5232 12.7154 10.0298 13.5863C9.5262 14.4548 9.26709 15.9509 9.26709 18.5849V18.5939C9.26709 21.2165 9.5262 22.7239 10.0298 23.5834C10.5232 24.4532 11.0538 24.6109 12.132 24.6841C13.2112 24.7472 15.9263 24.7844 18.2819 24.7844C20.6331 24.7844 23.347 24.7472 24.4274 24.6852C25.5077 24.612 26.0384 24.4543 26.5273 23.5846C27.0354 22.725 27.2922 21.2176 27.2922 18.595V18.586C27.2922 15.9509 27.0354 14.4548 26.5262 13.5863ZM16.0265 21.9679V15.2085L21.6594 18.5882L16.0265 21.9679Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 18.2771,
    cy: 18.0251,
    r: 17.6496,
    stroke: "#5D5D5D",
    strokeWidth: 0.751047
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5991,
    fill: "white",
    transform: "translate(-352 -5660)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.0251,
    height: 18.0251,
    fill: "white",
    transform: "translate(9.26611 9.01245)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3bf2a714ff30d4465a3ab6a456d81344.svg";
export { ForwardRef as ReactComponent };